import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 安否確認(家族)施設状況 API 操作クラス
 */
export default class SafetyConfirmFacilityStatuses {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET SafetyConfirmFacilityStatus
   */
  public async get(userStore: LoginUser, safetyConfirmsId: number): Promise<SafetyConfirmFacilityStatusGetModel> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      safetyConfirmsId: safetyConfirmsId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmFacilityStatus, formatParams);

    const response = await this.commonService.executeGet<SafetyConfirmFacilityStatusGetModel>(
      userStore,
      requestUrl,
      this.constructor.name,
      null,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * ### POST SafetyConfirmFacilityStatus
   */
  public async post(userStore: LoginUser, safetyConfirmsId: number, requestBody: SafetyConfirmFacilityStatusPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      safetyConfirmsId: safetyConfirmsId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmFacilityStatus, formatParams);

    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * ### PATCH SafetyConfirmFacilityStatus
   */
  public async patch(userStore: LoginUser, safetyConfirmsId: number, requestBody: SafetyConfirmFacilityStatusPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      safetyConfirmsId: safetyConfirmsId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmFacilityStatus, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SafetyConfirmFacilityStatusGetModel {
  /** 施設ID */
  facilityId: number;
  /** 災害ID */
  safetyConfirmsId: number;
  /** 入力した施設状況 */
  statuses: Array<SafetyConfirmFacilityStatusContents>;
  /** 削除フラグ */
  deleteFlag: boolean;
  /** レコード作成日 */
  created: number;
  /** レコード更新日 */
  updated: number;
}

export interface SafetyConfirmFacilityStatusContents {
  /** 回答元のID。familySafetyConfirmMastersのIDにひもづく */
  id: number;
  /** 回答内容 */
  answer: string;
}

export interface SafetyConfirmFacilityStatusPostModel {
  /** 入力した施設状況 */
  statuses: Array<SafetyConfirmFacilityStatusContents>;
}

export interface SafetyConfirmFacilityStatusPatchModel {
  /** 入力した施設状況 */
  statuses: Array<SafetyConfirmFacilityStatusContents>;
  /** レコード更新日 */
  updated: number;
}
